import { configureStore } from "@reduxjs/toolkit";

import config from "console_config";
import { getIntl } from "Libs/intl";
import { navigationMiddleware } from "src/reducers/navigationMiddleware";

import rootReducer from "../reducers/";

import analyticsMiddleware from "./analytics";
import { listenerMiddleware } from "./listenerMiddleware";

// Import listeners to register them with the middleware
// eslint-disable-next-line import/no-unassigned-import
import "../reducers/projectCreation/projectCreation.listeners";
// eslint-disable-next-line import/no-unassigned-import
import "../reducers/organization/projects/projects.listeners";
// eslint-disable-next-line import/no-unassigned-import
import "../reducers/environment/environmentTasks/environmentTasks.listeners";
// eslint-disable-next-line import/no-unassigned-import
import "../reducers/environment/git/git.listeners";
// eslint-disable-next-line import/no-unassigned-import
import "../reducers/activity/taskActivities.listeners";
// eslint-disable-next-line import/no-unassigned-import
import "../reducers/integration/integration.listeners";
// Feature-scoped: only the performance-agent Run modal needs it.
// eslint-disable-next-line import/no-unassigned-import
import "../organization/common/containers/TaskContainers/runTaskVariants/performanceAgent/performanceAgent.listeners";
// Feature-scoped: streams a troubleshooting run's log and toasts its report.
// eslint-disable-next-line import/no-unassigned-import
import "../organization/common/containers/TaskContainers/runTaskVariants/agentRuns.listeners";

const middlewares = [analyticsMiddleware, navigationMiddleware];

const isDevToolsEnabled = () => {
  // Always enable in development
  if (process.env.NODE_ENV !== "production") {
    return true;
  }
  // Check environment variable via config
  if (config.ENABLE_REDUX_DEVTOOLS) {
    return true;
  }
  // Check localStorage for runtime toggle (set via admin panel)
  try {
    return localStorage.getItem("ENABLE_REDUX_DEVTOOLS") === "true";
  } catch {
    return false;
  }
};

export const configureAppStore = (preloadedState = {}) => {
  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
    devTools: isDevToolsEnabled(),
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
        thunk: { extraArgument: { getIntl } }
      })
        .prepend(listenerMiddleware.middleware)
        .concat(middlewares)
  });

  return store;
};

type store = ReturnType<typeof configureAppStore>;

export type GetState = store["getState"];
export type RootState = ReturnType<GetState>;
export type AppDispatch = store["dispatch"];

export default configureAppStore;
